document.addEventListener('DOMContentLoaded', () => {
  console.log('BASE JS LADATTU');

  const priceContainers = document.querySelectorAll('[id^="price-"]');

  priceContainers.forEach((container) => {
    let lastPrice = '';

    const animatePrice = () => {
      const priceEl = container.querySelector('.price-item--regular');
      if (!priceEl) return;

      const newPrice = priceEl.textContent.trim();
      if (!newPrice) return;

      if (newPrice !== lastPrice) {
        lastPrice = newPrice;

        const normalizedPrice = newPrice.replace(/\s/g, '');

        if (normalizedPrice !== '12,90€') {
          priceEl.classList.remove('price-update-pop');
          void priceEl.offsetWidth;
          priceEl.classList.add('price-update-pop');
        }

        console.log('Hinta muuttui:', newPrice);
      }
    };

    animatePrice();

    const observer = new MutationObserver(() => {
      animatePrice();
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
});

let mobileLanguageWasOpen = false;

document.addEventListener(
  'pointerdown',
  function (event) {
    const button = event.target.closest('.header-language-mobile-visible .disclosure__button');
    if (!button) return;

    const wrapper = button.closest('.header-language-mobile-visible');
    const dropdown = wrapper.querySelector('.disclosure__list-wrapper');

    if (!dropdown) return;

    mobileLanguageWasOpen = !dropdown.hasAttribute('hidden');
  },
  true
);

document.addEventListener(
  'click',
  function (event) {
    const button = event.target.closest('.header-language-mobile-visible .disclosure__button');
    if (!button) return;

    const wrapper = button.closest('.header-language-mobile-visible');
    const dropdown = wrapper.querySelector('.disclosure__list-wrapper');

    if (!dropdown) return;

    if (mobileLanguageWasOpen) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      setTimeout(function () {
        button.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('hidden', '');
      }, 100);
    }
  },
  true
);